import { defineAction } from '~/prix'
import { z } from 'zod'
import materialDeliveryCreateAction from './materialDeliveryCreate.action.json' with { type: 'json' }
import { materialDeliveryItemObject, materialDeliveryObject } from '../materialDeliveryObject'

const materialDeliveryCreateDefinition = defineAction({
  ...materialDeliveryCreateAction,
  input: materialDeliveryObject
    .pick({
      id: true,
      materialRequestId: true,
      deliveryDate: true,
    })
    .partial({ id: true, deliveryDate: true })
    .extend({
      items: z
        .array(
          materialDeliveryItemObject
            .pick({
              id: true,
              materialRequestItemId: true,
              materialId: true,
              deliveredQuantity: true,
            })
            .partial({ id: true, materialRequestItemId: true }),
        )
        .min(1),
    }),
  output: z.object({
    id: materialDeliveryObject.shape.id,
    protocolId: z.string().uuid(),
    protocolCode: z.number().int().positive(),
  }),
})

export default materialDeliveryCreateDefinition
